<template>
  <base-section id="pro-features">
    <v-dialog
      v-model="dialog"
      max-width="600px"
      min-width="360px"
    >
      <div>
        <v-tabs
          v-model="tab"
          show-arrows
          icons-and-text
          dark
          grow
        >
          <v-tabs-slider />
          <v-tab
            v-for="(tab, i) in tabs"
            :key="i"
          >
            <v-icon large>
              {{ tab.icon }}
            </v-icon>
            <div class="caption py-1">
              {{ tab.name }}
            </div>
          </v-tab>
          <v-tab-item>
            <v-card class="px-4">
              <v-card-text>
                <v-form
                  ref="loginForm"
                  v-model="valid"
                  lazy-validation
                >
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="loginUsername"
                        :rules="loginUsernameRules"
                        label="Username"
                        required
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="loginPassword"
                        :append-icon="show1 ? 'eye' : 'eye-off'"
                        :rules="[rules.required, rules.min]"
                        :type="show1 ? 'text' : 'password'"
                        name="input-10-1"
                        label="Password"
                        hint="At least 8 characters"
                        counter
                        @click:append="show1 = !show1"
                      />
                    </v-col>
                    <v-col
                      class="d-flex xsm"
                      cols="12"
                      sm="6"
                    />
                    <v-spacer />
                    <v-col
                      class="d-flex xsm align-end"
                      cols="12"
                      sm="3"
                    >
                      <v-btn
                        x-large
                        block
                        :disabled="!valid"
                        color="success"
                        @click="validate"
                      >
                        Login
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </div>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      :timeout="timeout"
      :color="snackbarColor"
    >
      {{ text }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="blue"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </base-section>
</template>

<script>
  import LoginService from '../../service/loginService'
  import { mapActions } from 'vuex'

  export default {
    name: 'SectionProChart',

    data: () => ({
      snackbar: false,
      text: 'My timeout is set to 2000.',
      timeout: 2000,
      snackbarColor: 'success',
      dialog: true,
      tab: 0,
      tabs: [
        { name: 'Login', icon: 'mdi-account' },
      // { name: 'Register', icon: 'mdi-account-outline' },
      ],
      valid: true,

      firstName: '',
      lastName: '',
      email: '',
      password: '',
      verify: '',
      loginPassword: '',
      loginEmail: '',
      // loginEmailRules: [
      //   v => !!v || 'Required',
      //   v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      // ],
      loginUsername: '',
      loginUsernameRules: [v => !!v || 'Required'],
      emailRules: [
        v => !!v || 'Required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],

      show1: false,
      rules: {
        required: value => !!value || 'Required.',
        min: v => (v && v.length >= 8) || 'Min 8 characters',
      },
    }),
    computed: {
      passwordMatch () {
        return () => this.password === this.verify || 'Password must match'
      },
    },
    methods: {
      ...mapActions([ // spread operator so that other methods can still be added.
        'login',
      ]),
      validate () {
        debugger
        console.log(this.$store.state.isLoggedIn)

        if (this.$refs.loginForm.validate()) {
          const creds = {
            username: this.loginUsername,
            password: this.loginPassword,
          }
          LoginService.login(creds)
            .then(result => {
              console.log(result)
              if (result.status === 200) {
                this.login()

                this.snackbar = true
                this.text = 'Login Successful'
                this.snackbarColor = 'success'
              } else {
                this.snackbar = true
                this.text = 'Login Failed...'
                this.snackbarColor = 'fail'
              }
            })
            .catch(response => {
              if (response.response.status === 401) {
                this.snackbar = true
                this.text = 'Login Failed...'
                this.snackbarColor = 'fail'
              } else {
                this.snackbar = true
                this.text = 'Login service is down'
                this.snackbarColor = 'fail'
              }
            })
        }
      },
      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
    },
  }
</script>
